<div class="request-container">
  <div class="close" (click)="dialogRef.close(true)">
    <img src="assets/icons/news/close.svg" alt="close modal" />
  </div>
  <img src="/assets/icons/confirm.svg" alt="success_logo" />

  <p class="info-title">¡{{ title }}!</p>

  <div class="transfer-info" *ngIf="data.operation <= 2">
    <div class="row">
      <p class="subtitle">
        {{ data.operation === 0 ? 'Pagaste' : data.operation === 1 ? 'Vendiste' : 'Recibiste' }}
      </p>

      <p class="recieve-coin" *ngIf="data.operation === 0 && data.currency === 'USD'">
        {{ data.origAmount | currency : 'U$D' }}
      </p>

      <p class="recieve-coin" *ngIf="data.operation === 0 && data.currency === 'ARS'">
        {{ data.origAmount | currency : 'AR$' }}
      </p>

      <p
        class="recieve-coin"
        *ngIf="!data.isBundle && (data.operation === 1 || data.operation === 2)"
      >
        {{ data.amount | formatCoinAmount : data.coin }} {{ data.coin }}
      </p>
    </div>

    <div class="row">
      <p class="subtitle" *ngIf="!data.isBundle">
        {{ data.operation === 0 || data.operation === 1 ? 'Recibiste' : 'Desde la dirección' }}
      </p>
      <p class="recieve-coin" *ngIf="data.operation === 0 && !data.isBundle">
        {{ data.amount | formatCoinAmount : data.coin }} {{ data.coin }}
      </p>
      <p class="recieve-coin" *ngIf="data.operation === 1 && data.currency === 'ARS'">
        {{ data.origAmount | currency : 'AR$' }}
      </p>
      <p class="recieve-coin" *ngIf="data.operation === 1 && data.currency === 'USD'">
        {{ data.origAmount | currency : 'U$D' }}
      </p>
      <p class="recieve-address" *ngIf="data.operation === 2">
        {{ data.from }}
      </p>
    </div>
  </div>

  <div class="transfer-info" *ngIf="data.operation >= 3">
    <img [src]="'/assets/icons/crypto/' + data.coin.toLowerCase() + '.svg'" alt="ticker_logo" />
    <h3 class="subtitle">{{ data.operation === 3 ? 'Depositaste' : 'Retiraste' }}</h3>
    <p class="recieve-coin">{{ data.amount | number : '.0-8' }} {{ data.coin }}</p>
  </div>

  <button class="history-btn secondary" *ngIf="data.operation == 0" (click)="reviewBtnClicked()">
    <img src="assets/icons/link-white.svg" alt="link" />
    Dejar review en Google
  </button>
  <button class="history-btn secondary" *ngIf="data.operation <= 2" (click)="operationBtnClicked()">
    <img src="assets/icons/link-white.svg" alt="link" />
    {{ data.operation === 0 || data.operation === 1 ? 'Ver operación' : 'Ver depósito' }}
  </button>
  <button class="history-btn" *ngIf="data.operation === 1" (click)="openWithdraw()">
    <img src="assets/icons/withdraw.svg" alt="withdraw" />
    Retirar {{ data.currency === 'ARS' ? 'pesos' : 'dólares' }} a mi cuenta
  </button>
  <div class="history-btn" *ngIf="data.operation >= 3" (click)="dialogRef.close()">Aceptar</div>

  <p class="info-text" *ngIf="data.operation === 2">
    Tené en cuenta que los fondos serán acreditados luego de las
    <span class="number">12</span> confirmaciones.
  </p>
  <p class="info-text" *ngIf="data.operation === 3">
    A partir de mañana comenzarán a crecer tus {{ data.coin }}s.
  </p>
</div>
